export type AppMode = 'owner' | 'listener';

export type AppLocation = {
  pathname?: string;
  hash?: string;
};

export function resolveAppMode(location: AppLocation): AppMode {
  const pathname = location.pathname ?? '';
  const hash = location.hash ?? '';
  const ownerPath = pathname === '/owner' || pathname.startsWith('/owner/');
  const ownerHash = hash === '#/owner' || hash.startsWith('#/owner?') || hash.startsWith('#/owner/');
  return ownerPath || ownerHash ? 'owner' : 'listener';
}

export function modeFromLocation(): AppMode {
  return resolveAppMode(window.location);
}